import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button } from 'components';
import SubmitModal from '../../components/layout/components/submitModal';
import { isBeneficiary,isAuditor, outcomes } from 'utils';
import { isEmpty, isNil } from 'lodash';
import { getLocalString, localNames } from 'utils/localisation.service';
import { handleSubmit } from 'utils';
import { submitTask, updateFormField } from 'store/forms/actions';
import { useSupplierType } from 'hooks/useSupplierType';

const FormFooter = ({ actions, current, setCurrent,  currentSubTab, steps, tabs }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType()
  const locales = useSelector(state => state.forms?.localeStrings);
  const task = useSelector(state => state.forms.task);
  const state = useSelector(state => state.forms);
  const user = useSelector(state => state.user);
  const viewMode = useSelector(state => state.forms.carrier.viewMode);
  const [outcome, setOutcome] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const params = useParams();
  const location = useLocation();
  const appTrack = location.pathname.includes('apptrack');
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const [ currentTabReturnBtn, setCurrentTabReturnBtn ] = useState(0);
  const isForeignSupplier = useSelector(state => state.forms.carrier.isForeignSupplier);
  
  useEffect(() => {
    // Code to run on component mount
    if(isVisible && isAuditor(user?.groups)){
      setOutcome('return')
    }
  }, [isVisible]); 

  useEffect(() => {
    // Code to run when 'current' changes
  }, [current]);

  // Set current step based on user and Status
  useEffect(() => {
    
    if (isAuditor(user?.groups)) {
      if(isForeignSupplier) setCurrentTabReturnBtn(5); // Προμηθευτής Εξωτερικού
      else if (isIndirectSupplier && isDirectSupplier) setCurrentTabReturnBtn(6); // Άμεσος και Έμμεσος
      else if(isIndirectSupplier && !isDirectSupplier) setCurrentTabReturnBtn(3); // Έμμεσος
      else if(!isIndirectSupplier && isDirectSupplier) setCurrentTabReturnBtn(5); // Άμεσος
      else setCurrentTabReturnBtn(0);
    } else {
        setCurrentTabReturnBtn(0);
    }
  }, [user?.groups, isDirectSupplier, isIndirectSupplier]);

  const specialActions = [
    {
      label: 'Επιστροφή στον Προμηθευτή',
      type: 'default',
      id: 'return-btn',
      className: 'dark-grey',
      onClick: () => {
        setOutcome(outcomes.returnAuditor);
        setIsVisible(true);
      },
    },
  ].filter(Boolean);

  const commonActions = [
    current !== 0 && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      id: 'prev-step-button',
      className: 'dark-grey',
      onClick: () => {
        setCurrent(current - 1);
      },
    },
    current !== (!isNil(steps) ? steps.length - 1 : tabs.length - 1) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
      type: 'primary',
      id: 'next-step-btn',
      className: 'brown-grey',
      onClick: () => {
        setCurrent(current + 1);
      },
    },
  ].filter(Boolean);

  const commonActionsSub = [
    (currentSubTab !== 0 || current !== 0) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_PREVIOUSBUTTON),
      type: 'default',
      id: 'prev-step-button',
      className: 'dark-grey',
      onClick: () => currentSubTab !== 0? dispatch(
        updateFormField({
          group: 'carrier',
          key:'currentSubTab',
          value: currentSubTab -1 ,
        })
      ) : setCurrent(current - 1)
    },
    (current !== (tabs.length - 1 ) || current !== (!isNil(steps) ? steps.length - 1 : tabs.length - 1)) && {
      label: getLocalString(locales, localNames.REQUEST_PAGE_NEXTBUTTON),
      type: 'primary',
      id: 'next-step-btn',
      className: 'brown-grey',
      onClick: () => currentSubTab !== tabs[current]?.tabsComponent?.length -1 ? dispatch(
        updateFormField({
          group: 'carrier',
          key:'currentSubTab',
          value: currentSubTab + 1 ,
        })
      ) : setCurrent(current + 1)
    },
  ].filter(Boolean);

  return (
    <div className="form-footer">
      <SubmitModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        formKey={task.formKey}
        outcome={outcome}
        handleSubmit={() =>
          handleSubmit({
            state: { ...state },
            user: { ...user },
            dispatch,
            submitTask,
            navigate,
            setIsVisible,
            taskId: params.taskId,
            formKey: task.formKey,
            outcome,
            task,
            activeTaskName,
          })
        }
      />

      {/* Divider line */}
      <div className="form-footer__divider"></div>

      {/* Wrapper to handle button alignment */}
      <div className="form-footer__actions-wrapper">
      {(isAuditor(user?.groups) ) && current === currentTabReturnBtn && !viewMode && !window.location.href.includes('apptrack') && (
        <div className="form-footer__actions ">
          {!isEmpty(specialActions) &&
            specialActions?.map((action, index) => (
              <Button
                key={'special-btn-' + index}
                {...action}
              />
            ))}
        </div>
        )}
        <div className="form-footer__actions  right-placement">
          {tabs[current]?.subtabs ? commonActionsSub?.map((action, index) => (
            <Button key={index} {...action} />
          )) : 
          commonActions?.map((action, index) => (
              <Button
                key={'common-btn-' + index}
                {...action}
              />
            ))}
        </div>
      </div>
    </div>
  );
};

export default FormFooter;
